<div
  [matTooltip]="disabled ? disabledTooltip : 'Share this view'"
  matTooltipPosition="above"
  class="tw-inline-block">
  <button
    mat-stroked-button
    color="primary"
    (click)="onShareClick()"
    [disabled]="disabled"
    class="tw-flex tw-transition-all tw-text-base"
    id="share-this-view-button-start">
    <span class="tw-flex tw-items-center tw-gap-2">
      <img
        src="../../../assets/icons/ios-share.svg"
        alt="Share this view"
        class="tw-w-5 tw-pb-1"
        aria-hidden="true" />
      <span class="tw-hidden sm:tw-block">{{ label }}</span>
    </span>
  </button>
</div>
<span class="tw-hidden sm:tw-block tw-text-sm tw-text-gray-500 tw-w-full tw-text-right"
  >* no login required</span
>
